import livejasmin from './livejasmin_theme.module.scss';
import oranum from './oranum_theme.module.scss';
import common from './common_theme.module.scss';

Object.assign(livejasmin, oranum, common);

export default livejasmin;
